import { createRouter, createWebHistory } from 'vue-router';
import MainRoutes from './MainRoutes';
import AuthRoutes from './AuthRoutes';
import PublicRoutes from './PublicRoutes';
import { useAuthStore } from '@/stores/auth';
import { usePermission, type Action, type Subject, type Permission } from '@/permissions';
import { useUIStore } from '@/stores/ui';

declare module 'vue-router' {
  interface RouteMeta {
    permission?: Permission;
  }
}

export const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_BASE_URL),
  routes: [
    AuthRoutes,
    MainRoutes,
    PublicRoutes,
    {
      path: '/:pathMatch(.*)*',
      component: () => import('@/layouts/blank/BlankLayout.vue'),
      children: [
        {
          path: '',
          component: () => import('@/views/pages/maintenance/error/Error404Page.vue'),
        },
      ],
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPaths = ['/public/terms-of-use', '/public/privacy-policy'];
  const authRequired = !to.path.startsWith('/auth') && !publicPaths.includes(to.path);
  const auth = useAuthStore();
  const { can } = usePermission();

  if (authRequired && !auth.jwt) {
    auth.returnUrl = to.fullPath;
    return next('/auth/login');
  }

  const permission = to.meta?.permission;
  if (permission && !can(permission.action as Action, permission.subject as Subject)) {
    return next('/error403');
  }
  next();
});

router.beforeEach(() => {
  const uiStore = useUIStore();
  uiStore.isLoading = true;
  // uiStore.startAPICall();
});

router.afterEach(() => {
  const uiStore = useUIStore();
  uiStore.isLoading = false;
  // uiStore.endAPICall();
});
